import {get, post, put} from "../helpers/api_helper"

export const CommonOrderService = {
    getCommonOrders: async (params?: any) => {
        const queryString = params ? `?${new URLSearchParams(params).toString()}` : '';
        return get(`/traffic-orders-common${queryString}`)
    },

    getCommonOrdersWaiting: async (params?: any) => {
        const queryString = params ? `?${new URLSearchParams(params).toString()}` : '';
        return get(`/traffic-orders-common/waiting${queryString}`)
    },

    getCommonOrdersNotActive: async (params?: any) => {
        const queryString = params ? `?${new URLSearchParams(params).toString()}` : '';
        return get(`/traffic-orders-common/not_active${queryString}`)
    },

    getCommonOrder: async (id: number) => {
        return get(`/traffic-orders-common/${id}`)
    },

    createCommonOrder: async (data: any) => {
        return post('/traffic-orders-common', data)
    },

    updateCommonOrder: async (id: number, data: any) => {
        return put(`/traffic-orders-common/${id}`, data)
    },

    getStatusCommonOrder: async (id: number, date: string) => {
        return get(`/traffic-orders-common/${id}/get_status`, {params: {date}});
    },

    updateStatusCommonOrder: async (id: number, data: any) => {
        return post(`/traffic-orders-common/${id}/status`, data);
    }
}